import React from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import SuccessArea from "../../components/SuccessArea/SuccessArea";
import InnerServicesArea from "../../components/ServicesArea/InnerServicesArea";
import InnerServiceAre from "../../components/ServicesArea/innerServiceAre";
import DocumentMeta from "react-document-meta";
import { Helmet } from "react-helmet";

function ServicePage() {
  return (
    <>
      <Helmet>
        <title>Services – Innovatix Hub Australia</title>
        <meta
          name="description"
          content="Discover Innovatix Hub's creative design. From branding to web design, we provide creative solutions to elevate your business. Contact us today to get started!"
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Innovatix Hub" />
        <meta
          property="og:title"
          content="Services – Innovatix Hub Australia"
        />
        <meta
          property="og:description"
          content="Discover Innovatix Hub's creative design. From branding to web design, we provide creative solutions to elevate your business. Contact us today to get started!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="Innovatix Hub AU" />
        <meta
          property="og:url"
          content="https://innovatixhub.com.au/services"
        />
        <meta
          property="og:image"
          content="https://innovatixhub.com.au/img/logo1.png"
        />

        <link rel="canonical" href="https://innovatixhub.com.au/services" />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title="Our Services"
          subtitle={"Services"}
          className={"pt-175 pb-140"}
        />
        <InnerServiceAre />
      </Layout>
    </>
  );
}

export default ServicePage;
